module.exports = __webpack_public_path__ + "img/6c95396e8ec959908a1177c34dbe5fb8.34459c0b.jpg";